/**
 * BancaDatiNotifier — notifica desktop (toast) quando un operatore officina invia valori
 * alla banca dati (iniettore o apparato). Ascolta i socket globali via useSharedWebSocket, così
 * l'avviso arriva su QUALSIASI pagina desktop. Il push mobile è gestito a parte dal backend.
 * Montato una sola volta in App (dentro ToastProvider). Non renderizza nulla.
 */
import { useEffect } from 'react';
import { useToast } from '../ui/ToastProvider';
import { registerMessageHandler } from '../../hooks/useSharedWebSocket';

export default function BancaDatiNotifier() {
  const { showInfo } = useToast();

  useEffect(() => {
    const chiDi = (d: any) => (d?.created_by_user_name && String(d.created_by_user_name).trim()) || 'Un operatore';

    const unregInj = registerMessageHandler('banca_dati:richiesta_iniettore_creata', (d: any) => {
      const cod = d?.codice_iniettore || 'iniettore';
      showInfo(
        '🔔 Nuova richiesta banca dati',
        `${chiDi(d)} suggerisce i valori per l'iniettore ${cod}. Vai a Database iniettori per vederli.`,
        12000
      );
    });

    const unregApp = registerMessageHandler('banca_dati:richiesta_apparato_creata', (d: any) => {
      const cod = d?.codice_apparato || 'apparato';
      showInfo(
        '🔔 Nuova richiesta banca dati',
        `${chiDi(d)} suggerisce i valori per l'apparato ${cod}. Vai a Banca dati › Richieste per vederli e approvarli.`,
        12000
      );
    });

    return () => { try { unregInj?.(); } catch { /* ignore */ } try { unregApp?.(); } catch { /* ignore */ } };
  }, [showInfo]);

  return null;
}
